var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NewPaymentsCreateAdmin',{attrs:{"pm":_vm.pm,"serverError":_vm.serverError},on:{"createPayment":_vm.createPayment}})
}
var staticRenderFns = []

export { render, staticRenderFns }